import { render, staticRenderFns } from "./FormLabel.vue?vue&type=template&id=596bae90&scoped=true&"
import script from "./FormLabel.vue?vue&type=script&lang=js&"
export * from "./FormLabel.vue?vue&type=script&lang=js&"
import style0 from "./FormLabel.vue?vue&type=style&index=0&id=596bae90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596bae90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/tafelgasten/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('596bae90')) {
      api.createRecord('596bae90', component.options)
    } else {
      api.reload('596bae90', component.options)
    }
    module.hot.accept("./FormLabel.vue?vue&type=template&id=596bae90&scoped=true&", function () {
      api.rerender('596bae90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Checkout/Components/Common/FormLabel.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Checkout/Components/Common/FormLabel.vue
// module id = 54
// module chunks = 0